import axios from 'axios'
import api from '../api'
import { Attachment, AttachmentLink, AttachmentsFolder, UpdateAttachmentData, UploadRequestOptions } from './attachmentsModel'

export const getAttachmentFolders = async (customerId: number, propertyId?: number, includeAll?: boolean): Promise<AttachmentsFolder[]> => {
  const url = propertyId !== undefined ?
    `web/attachments/properties/${propertyId}/folders?includeAll=${includeAll ?? true}` :
    `web/attachments/customers/${customerId}/folders?includeAll=${includeAll ?? true}`

  return (await api.get<AttachmentsFolder[]>(url)).data
}

export const getAttachmentsInFolder = async (folder: string, customerId: number, propertyId?: number, jobId?: number): Promise<Attachment[]> => {
  const encodedFolder = encodeURIComponent(folder)
  const url =
    jobId ? `web/attachments/jobs/${jobId}` :
    propertyId !== undefined ?  `attachments/properties/${propertyId}/folders/${encodedFolder}`
    : `attachments/customers/${customerId}/folders/${encodedFolder}`

  return (await api.get<Attachment[]>(url)).data
}

export const getAttachmentsForCustomer = async (customerId: number): Promise<Attachment[]> => {
  return (await api.get<Attachment[]>(`/attachments/customers/${customerId}/all-attachments`)).data
}

export const uploadAttachment = async ({ attachment, filename, file, uid, onProgress, onSuccess, onError }: UploadRequestOptions) => {
  try {
    const links = (await api.post<{ links: AttachmentLink[] }>('attachments/link', { filenames: [filename] })).data.links
    const promises = links.map(async link => {
      const unauthenticatedClient = axios.create()
      await unauthenticatedClient.put(link.link, file, {
        headers: {
          'Content-Type': link.contentType
        },
        onUploadProgress: ({ total, loaded }) => {
          const progress = Math.round((loaded / (total ?? 1)) * 100)
          onProgress(uid, Math.round(progress))
        }
      })

      await api.post('attachments/uploaded', [{
        ...attachment,
        id: link.attachmentId,
        customerId: attachment.customerId,
        propertyId: attachment.propertyId,
        name: attachment.name,
        filename,
        tags: attachment.tags,
      }])
    })

    await Promise.allSettled(promises)

    onSuccess(uid)
  } catch (error) {
    onError(uid)
  }
}

export const getAttachmentTags = async (): Promise<string[]> => {
  return (await api.get<string[]>('attachments/tags?search=')).data
}

export const updateAttachment = async (attachment: UpdateAttachmentData) => {
  return (await api.post('attachments/section/0/update', attachment)).data
}

export const deleteAttachment = async (attachmentId: string) => {
  return (await api.delete(`attachments/section/0/delete/${attachmentId}`)).data
}

export const getPropertyPhotos = async (customerId: number, propertyId: number): Promise<Attachment[]> => {
  return (await api.get<Attachment[]>(`attachments/photos/${customerId}/${propertyId}/`)).data
}
